import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { IQuickInputService } from '../common/quickInput.js';
import { Extensions } from '../common/quickAccess.js';
import { Registry } from '../../registry/common/platform.js';
import { localize } from '../../../nls.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';

var HelpQuickAccessProvider = /*#__PURE__*/function () {
  function HelpQuickAccessProvider(quickInputService) {
    _classCallCheck(this, HelpQuickAccessProvider);

    this.quickInputService = quickInputService;
    this.registry = Registry.as(Extensions.Quickaccess);
  }

  _createClass(HelpQuickAccessProvider, [{
    key: "provide",
    value: function provide(picker) {
      var _this = this;

      var disposables = new DisposableStore(); // Open a picker with the selected value if picked

      disposables.add(picker.onDidAccept(function () {
        var _picker$selectedItems = _slicedToArray(picker.selectedItems, 1),
            item = _picker$selectedItems[0];

        if (item) {
          _this.quickInputService.quickAccess.show(item.prefix, {
            preserveValue: true
          });
        }
      })); // Also open a picker when we detect the user typed the exact
      // name of a provider (e.g. `?term` for terminals)

      disposables.add(picker.onDidChangeValue(function (value) {
        var providerDescriptor = _this.registry.getQuickAccessProvider(value.substr(HelpQuickAccessProvider.PREFIX.length));

        if (providerDescriptor && providerDescriptor.prefix && providerDescriptor.prefix !== HelpQuickAccessProvider.PREFIX) {
          _this.quickInputService.quickAccess.show(providerDescriptor.prefix, {
            preserveValue: true
          });
        }
      })); // Fill in all providers separated by editor/global scope

      var _this$getQuickAccessP = this.getQuickAccessProviders(),
          editorProviders = _this$getQuickAccessP.editorProviders,
          globalProviders = _this$getQuickAccessP.globalProviders;

      picker.items = editorProviders.length === 0 || globalProviders.length === 0 ? // Without groups
      _toConsumableArray(editorProviders.length === 0 ? globalProviders : editorProviders) : // With groups
      [{
        label: localize('globalCommands', "global commands"),
        type: 'separator'
      }].concat(_toConsumableArray(globalProviders), [{
        label: localize('editorCommands', "editor commands"),
        type: 'separator'
      }], _toConsumableArray(editorProviders));
      return disposables;
    }
  }, {
    key: "getQuickAccessProviders",
    value: function getQuickAccessProviders() {
      var globalProviders = [];
      var editorProviders = [];

      var _iterator = _createForOfIteratorHelper(this.registry.getQuickAccessProviders().sort(function (providerA, providerB) {
        return providerA.prefix.localeCompare(providerB.prefix);
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var provider = _step.value;

          if (provider.prefix === HelpQuickAccessProvider.PREFIX) {
            continue; // exclude help which is already active
          }

          var _iterator2 = _createForOfIteratorHelper(provider.helpEntries),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var helpEntry = _step2.value;
              var prefix = helpEntry.prefix || provider.prefix;
              var label = prefix || "\u2026"
              /* ... */
              ;
              (helpEntry.needsEditor ? editorProviders : globalProviders).push({
                prefix: prefix,
                label: label,
                ariaLabel: localize('helpPickAriaLabel', "{0}, {1}", label, helpEntry.description),
                description: helpEntry.description
              });
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        editorProviders: editorProviders,
        globalProviders: globalProviders
      };
    }
  }]);

  return HelpQuickAccessProvider;
}();

HelpQuickAccessProvider.PREFIX = '?';
HelpQuickAccessProvider = __decorate([__param(0, IQuickInputService)], HelpQuickAccessProvider);
export { HelpQuickAccessProvider };